import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';
import './ComponentPopup.css';

const ComponentPopup = ({
  isOpen = false,
  onClose,
  title = '',
  subtitle = '',
  icon = null,
  headerActions = null,
  Component = null,
  componentProps = {},
  previewUrl = null,
  maxWidth = '1100px',
  maxHeight = '90vh',
  className = '',
  enableLivePreview = false,
  children,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const TargetComponent = Component;

  const [timestamp, setTimestamp] = useState(Date.now());

  useEffect(() => {

    if (isOpen) {
      setTimestamp(Date.now());
    }
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="comp-popup-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className={`comp-popup-container ${className} ${isFullscreen ? 'comp-popup-fullscreen' : ''} ${previewUrl ? 'comp-popup-has-webview-container' : ''}`}
            style={isFullscreen ? {} : { maxWidth, maxHeight, ...(previewUrl ? { height: '88vh' } : {}) }}
            initial={{ opacity: 0, scale: 0.9, y: 40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 40 }}
            transition={{ type: 'spring', damping: 25, stiffness: 320 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Popup Header */}
            <div className="comp-popup-header">
              <div className="comp-popup-header-right">
                {icon && (
                  <div className="comp-popup-icon-badge">
                    {typeof icon === 'object' && icon.icon ? (
                      <FontAwesomeIcon icon={icon} />
                    ) : (
                      icon
                    )}
                  </div>
                )}
                <div className="comp-popup-title-box">
                  {title && <h3>{title}</h3>}
                  {subtitle && <div className="comp-popup-subtitle">{subtitle}</div>}
                </div>
              </div>

              <div className="comp-popup-header-left">
                {headerActions && <div className="comp-popup-actions">{headerActions}</div>}
                <button
                  className="comp-popup-fullscreen-btn"
                  onClick={() => setIsFullscreen((prev) => !prev)}
                  title={isFullscreen ? 'تصغير' : 'ملء الشاشة'}
                >
                  <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
                </button>
                {onClose && (
                  <button className="comp-popup-close-btn" onClick={onClose} title="إغلاق">
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}
              </div>
            </div>

            {/* Popup Body */}
            <div className={`comp-popup-body ${enableLivePreview ? 'comp-popup-live-preview' : ''} ${previewUrl ? 'comp-popup-has-webview' : ''}`}>
              {previewUrl ? (
                <div className="comp-popup-webview-container">
                  <iframe
                    src={`${previewUrl}${previewUrl.includes('?') ? '&' : '?'}t=${timestamp}`}
                    title={title || 'Live Preview'}
                    className="comp-popup-webview-iframe"
                  />
                </div>
              ) : TargetComponent ? (
                <TargetComponent {...componentProps} />
              ) : (
                children
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ComponentPopup;
